import GalleryEditor from './GalleryEditor';

export default GalleryEditor;
